import { OVERLAY_CLICKED } from "./types";

export const OverlayClicked = () => {
  return {
    type: OVERLAY_CLICKED,
  };
};